// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { ServiceBreakLocationsAreaRoutes } from '@backoffice-frontend/service-break-locations-api'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { ServiceBreakLocationsAreaId } from './ServiceBreakLocationsAreaId'

import {
  ServiceBreakLocationsAreaNavigation,
  ServiceBreakLocationsAreaNavigationIcon,
} from './ServiceBreakLocationsAreaNavigation'

const LazyServiceBreakLocationsComponent = lazy(
  () => import('./ServiceBreakLocationsArea'),
)

const ServiceBreakLocationsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyServiceBreakLocationsComponent />
  </SuspenseLoadingWrapper>
)

export const ServiceBreakLocationsArea = {
  id: ServiceBreakLocationsAreaId,
  requiredRight: BoumRight.AREA_SERVICE_BREAK_LOCATIONS,
  Icon: ServiceBreakLocationsAreaNavigationIcon,
  NavigationComponent: ServiceBreakLocationsAreaNavigation,
  route: {
    path: ServiceBreakLocationsAreaRoutes.route,
    component: ServiceBreakLocationsComponent,
  },
}
